module.exports = __webpack_public_path__ + "static/mobilitat5-539cfbaf274c480ee5c5ad74d121b818.png";